/**
 * To use this module, add the following data attribute to any element in your html:
 * data-js-module="infinite-scroll"
 */
export default class InfiniteScroll {
    constructor() {
        this.init();
    }

    init() {
        let page = 1;
        let isLoading = false;
        const url = window.location.origin + window.location.pathname;
        const urlParams = window.location.search
            .slice(1)
            .split('&')
            .reduce(
                (params, current) => {
                    const [key, val] = current.split('=');
                    if (key.length) {
                        params[key] = decodeURIComponent(val);
                    }
                    return params;
                },
                {},
            );

        window.addEventListener('scroll', () => {
            const element = document.getElementById('load-more');
            if (!isLoading && element && window.scrollY + window.innerHeight >= element.offsetTop) {
                isLoading = true;
                urlParams.page = ++page;
                const xhr = new XMLHttpRequest();
                const searchParams = Object.keys(urlParams)
                    .map((key) => `${key}=${urlParams[key]}`)
                    .join('&');
                xhr.open('GET', `${url}?${searchParams}`);
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

                xhr.onload = () => {
                    isLoading = false;
                    const { responseText } = xhr;
                    const parser = new DOMParser();
                    const htmlContent = parser.parseFromString(responseText, 'text/html');
                    let content = '';
                    if (htmlContent.getElementById('content')) { content = htmlContent.getElementById('content').innerHTML; }
                    if (document.getElementById('content')) { document.getElementById('content').innerHTML += content; }
                };
                xhr.send();
            }
        });
    }
}
